/**
 * @generated SignedSource<<bec53757a3abc3c23af1cf5fa229db4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FollowButton_favoritesConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly __id: string;
      readonly serviceId: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "FollowButton_favoritesConnection";
};
export type FollowButton_favoritesConnection$key = {
  readonly " $data"?: FollowButton_favoritesConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"FollowButton_favoritesConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FollowButton_favoritesConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "favoritesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Favorite",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "favoritesConnection",
  "abstractKey": null
};

(node as any).hash = "f47fe3b1d090fa9518687159ed1c0fe5";

export default node;
